import { FONT_WEIGHT } from '@app/styles/themes/constants';
import ReactQuill from 'react-quill';
import styled from 'styled-components';

export const ReactQuillWrapper = styled(ReactQuill)`
  font-weight: ${FONT_WEIGHT.regular};

  &.editor-rtl {
    .ql-editor {
      direction: rtl;
      text-align: right;
    }

    .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
      left: 0;
      right: unset;
    }
    p {
      font-weight: ${FONT_WEIGHT.regular};
    }
  }
`;
